import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=1a443792&scoped=true&"
import script from "./DownloadView.vue?vue&type=script&lang=js&"
export * from "./DownloadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a443792",
  null
  
)

export default component.exports